import React from "react";
import { Card, CardContent, Typography } from "@mui/material";

interface LoadingPanelProps {
  message?: string;
  height?: string | number;
  fullScreen?: boolean;
}

const LoadingPanel: React.FC<LoadingPanelProps> = ({
  message = "Loading...",
  height = "200px",
  fullScreen = false,
}) => {
  return (
    <div
      style={{
        position: fullScreen ? "fixed" : "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: fullScreen ? "100vh" : height,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: fullScreen ? "rgba(0, 0, 0, 0.5)" : "transparent",
        zIndex: 9999,
      }}
    >
      <Card sx={{ width: fullScreen ? "auto" : "300px", boxShadow: 3 }}>
        <CardContent>
          <div className="d-flex flex-column align-items-center">
            <div className="spinner-border text-primary mb-3" role="status" />
            <Typography variant="body1">{message}</Typography>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default LoadingPanel;
